module.exports = __webpack_public_path__ + "img/contact-header.c212fef3.jpg";